import { render, staticRenderFns } from "./AddEquipment.vue?vue&type=template&id=052baa1a&scoped=true"
import script from "./AddEquipment.vue?vue&type=script&lang=js"
export * from "./AddEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052baa1a",
  null
  
)

export default component.exports